// src/app/providers/sessionProvider.tsx
"use client";

import { ReactNode } from "react";
import { SessionProvider } from "next-auth/react";

// Definindo a tipagem para as props do componente.
interface NextAuthSessionProviderProps {
  children: ReactNode; // A propriedade children é obrigatória e representa os componentes filhos que usarão a sessão.
}

export default function NextAuthSessionProvider({
  children,
}: NextAuthSessionProviderProps) {
  /**
   * O SessionProvider fornece o contexto de sessão para a aplicação.
   * Ele permite que componentes filhos acessem a sessão, realizando o refetch de forma periódica.
   *
   * - refetchInterval: Verifica a sessão a cada 5 minutos para garantir que as informações de sessão estejam atualizadas.
   * - refetchOnWindowFocus: Garante que a sessão seja recarregada quando a janela do navegador voltar ao foco.
   * - refetchWhenOffline: Não tenta atualizar a sessão quando o usuário está offline.
   */

  return (
    <SessionProvider
      refetchInterval={5 * 60} // Atualiza a sessão a cada 5 minutos
      refetchOnWindowFocus={true} // Atualiza a sessão quando a janela voltar a ter foco
      refetchWhenOffline={false} // Não tenta atualizar quando offline
    >
      {children}
    </SessionProvider>
  );
}
